import { RegisterTranslate } from '../register/registerTranslate.model';

const registerTranslateEN: RegisterTranslate = {
  title: {
    new: {
      lead: 'Add a new lead',
      event: 'Add a new event',
    },
    editing: {
      lead: 'Editing lead',
      event: 'Editing event',
    },
  },
  fields: {
    name: 'Name',
    email: 'E-mail',
    password: 'Password',
    passwordConfirmation: 'Re-enter password',
    role: 'Role',
    phone: 'Phone number',
    instagram: 'Instagram',
    notes: 'Notes',
    lead: 'Lead',
    leadNone: 'No lead',
    leadSearchPlaceholder: 'Search lead',
    leadNoResults: 'No lead found',
    description: 'Description',
    date: 'Date',
    time: 'Time',
    location: 'Location',
    status: 'Status',
    source: 'Source',
    sourceNone: 'No source',
    referrer: 'Referred by',
    checklist: 'Apply checklist',
    checklistNone: 'No checklist',
    badges: 'Badges',
  },
  errors: {
    name: {
      required: 'Name is required',
      invalid: 'Name must contain only letters and spaces',
    },
    email: {
      required: 'E-mail is required',
      invalid: 'Invalid e-mail format',
    },
    password: {
      required: 'Password is required',
      invalid: 'Password must contain at least 8 characters',
    },
    passwordConfirmation: {
      invalid: 'Password confirmation must be the same as password',
    },
    role: {
      required: 'Role is required',
    },
    phone: {
      invalid: 'Phone number must contain less than 30 characters',
    },
    instagram: {
      invalid: 'Instagram must contain less than 30 characters',
      invalidUserName: 'Invalid Instagram username',
    },
    notes: {
      invalid: 'Notes must contain less than 300 characters',
    },
    location: {
      invalid: 'Location must contain less than 100 characters',
    },
    description: {
      required: 'Description is required',
      invalid: 'Description must contain less than 100 characters',
    },
    date: {
      invalid: 'Date must be in MM/dd/yyyy format',
    },
  },
  submit: 'Save changes',
  clearFields: 'Clear fields',
  timePicker: {
    apply: 'Apply',
    cancel: 'Cancel',
    triggerLabel: 'Select time',
  },
  toast: {
    lead: {
      created: 'Lead added successfully',
      updated: 'Lead updated successfully',
      error: 'Error creating lead',
      partialBadges:
        'Lead saved, but {{count}} badge(s) could not be applied. Review before closing.',
    },
    event: {
      created: 'Event added successfully',
      updated: 'Event updated successfully',
      error: 'Error creating event',
    },
  },
  select: {
    eventStatus: {
      SCHEDULED: 'Scheduled',
      COMPLETED: 'Completed',
      CANCELED: 'Canceled',
      EDITING: 'Editing',
      DELIVERED: 'Delivered',
      ARCHIVED: 'Archived',
    },
  },
};

export default registerTranslateEN;
